import { IonIcon, IonItem, IonLabel, IonList, RouterDirection } from "@ionic/react";
import { RouterMap } from "navigation/RouterMap";
import { Language, DeviceConnectionCTX } from "functions/Context";
import { Glob }                          from "functions/Language";
import { DeviceInfo, SupportedDevices }  from "functions/networking/NetTypes";
import { FC } from "react";

export type DvcPage = {
  title : Glob<{ title : string }>,
  icon? : string,

  path : typeof RouterMap[keyof typeof RouterMap],
  page : FC,

  available? : (dvc : DeviceInfo<SupportedDevices>) => boolean
}

export const PageList : FC<{
  pages : DvcPage[],
  routerDirection : RouterDirection
}> = (props) =>
  <IonList>
    <DeviceConnectionCTX.Consumer>{ctx =>
      <Language.Consumer>{lng =>
        props.pages.filter(p => !p.available || p.available(ctx!.device)).map((v, i) =>
        <IonItem key={i} routerLink={v.path} routerDirection={props.routerDirection}>
          {v.icon && <><IonIcon icon={v.icon} />&nbsp;</>}
          <IonLabel>{v.title[lng].title}</IonLabel>
        </IonItem>)
      }</Language.Consumer>
    }</DeviceConnectionCTX.Consumer>
  </IonList>

